import { createSelector } from 'reselect';

// Config
import { PAYMENT_BLOCKERS } from '@components/payment-option-unavailable/PaymentOptionUnavailable.config';
import { PAYPAL_PAY_LATER_MAX_SPEND, PAYPAL_PAY_LATER_MIN_SPEND } from '@constants/paymentConstants';
import { getDeliveriesWithClearabee } from '@redux/reducers/delivery/deliverySelector';
import { getOutstandingBalanceRawSelector } from '@redux/reducers/order-form/orderFormSelector';
import { getPayPalPayLaterIsNotEligibleSelector } from '@redux/reducers/payment/paymentSelector';

import isPayPalAvailable from './isPayPalAvailable';

export type PayPalPayLaterEligibilityType = {
  isEligible: boolean;
  isEnabled: boolean;
  reasons: (typeof PAYMENT_BLOCKERS)[keyof typeof PAYMENT_BLOCKERS][];
};

export const selectPaypalPayLaterIneligibilityReasons = createSelector(
  [getDeliveriesWithClearabee, getOutstandingBalanceRawSelector],
  (deliveriesWithClearabee = [], outstandingBalanceRaw) => {
    const reasons: (typeof PAYMENT_BLOCKERS)[keyof typeof PAYMENT_BLOCKERS][] = [];

    if (deliveriesWithClearabee.length > 0) {
      reasons.push(PAYMENT_BLOCKERS.CLEARABEE_DELIVERIES);
    }
    if (Number(outstandingBalanceRaw) < PAYPAL_PAY_LATER_MIN_SPEND) {
      reasons.push(PAYMENT_BLOCKERS.BALANCE_BELOW_MIN);
    }
    if (Number(outstandingBalanceRaw) > PAYPAL_PAY_LATER_MAX_SPEND) {
      reasons.push(PAYMENT_BLOCKERS.BALANCE_ABOVE_MAX);
    }

    return reasons;
  },
);

export const isBasketPayPalPayLaterEligible = createSelector(
  [isPayPalAvailable, selectPaypalPayLaterIneligibilityReasons, getPayPalPayLaterIsNotEligibleSelector],
  (isPayPalAvailable, reasons, payPalPayLaterIsNotEligible) => ({
    isEligible: reasons.length === 0 && !payPalPayLaterIsNotEligible,
    isEnabled: isPayPalAvailable,
    reasons,
  }),
);
